// extracted by mini-css-extract-plugin
export default {"sec":"Section_sec__eEqpq","title":"Section_title__Lx6-a","folt":"Section_folt__JiKtx","block":"Section_block__nRcJZ","sec-no-title":"Section_sec-no-title__3nllZ"};